<!--使用頁面methods的使用範例-->
<!--...mapActions('dialogs', ['showDialog']),-->
<!--async showConfirmMessage() {-->
<!--try {-->
<!--await this.showDialog({ message: '你確定要進行此操作嗎？', type: 'confirm' });-->
<!--// 執行後續操作-->
<!--console.log('確認操作');-->
<!--} catch {-->
<!--// 中斷後續操作-->
<!--console.log('取消操作');-->
<!--}-->
<!--},-->
<!--async showAlertMessage() {-->
<!--await this.showDialog({ title: '警告', message: '這是一個警告訊息！', type: 'alert' });-->
<!--// 執行後續操作-->
<!--console.log('確認操作');-->
<!--},-->

<template>
  <div class="confirmation-dialog">
    <transition name="modal-fade">
      <div class="dialog-modal-backdrop" v-if="dialogVisible"></div>
    </transition>
    <transition name="modal-slide">
      <div class="dialog-modal-body" v-if="dialogVisible">
        <div class="dialog-content">
          <div class="title fs-20px fw-bold text-center" v-if="dialogTitle !== ''">{{ dialogTitle }}</div>
          <div class="desc fs-14px text-center">{{ dialogContent }}</div>
          <div class="button-list">
            <b-button block variant="primary" @click="confirm">確認</b-button>
            <b-button v-if="dialogType === 'confirm'" block variant="outline-primary" @click="cancel">取消</b-button>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: 'ConfirmationDialog',
  data() {
    return {
    };
  },
  components: {
  },
  computed: {
    ...mapGetters('dialogs', ['dialogVisible', 'dialogTitle', 'dialogContent', 'dialogType']),
  },
  mounted() {
  },
  methods: {
    ...mapActions("dialogs", ["confirm", "cancel"]),
  },
}
</script>

<style lang="scss" scoped>
@import "../assets/scss/basic";
.confirmation-dialog {
  .dialog-modal-backdrop {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 9000;
    width: 100%;
    height: var(--unit-100vh);
    background: $color-bk-tp-50;
  }
  .dialog-modal-body {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 9000;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: var(--unit-100vh);
    margin: 0 auto;
  }
  .dialog-content {
    width: 350px;
    background: $color-white;
    border-radius: 16px;
    box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
    padding: 1rem;
    .title, .desc {
      margin-bottom: 1.5rem;
    }
  }
}
</style>
<style lang="scss">
@import "../assets/scss/basic";
.confirmation-dialog {
  .btn-outline-primary, .btn-outline-primary:not(:disabled):hover, .btn-outline-primary:focus, .btn-outline-primary:not(:disabled):not(.disabled):active {
    border-color: $color-white;
  }
}
</style>
